<template>
  <div class="account-right">
    <div class="account-breadcrumb">
      <ul class="breadcrumb-innerpage">
        <li>
          <router-link :to="{ name: 'home' }">
            {{ _T('Home') }}
            <img src="/images/svg/global/arrow-right-r.svg" alt />
          </router-link>
        </li>
        <li>{{ _T('My Cashback') }}</li>
      </ul>
    </div>
    <div class="account-card">
      <div class="account-header">
        <h4 class="d-flex">
          <router-link :to="{ name: 'profile' }" class="d-sm-none d-block mr-2">
            <img src="/images/svg/global/left-arrow.svg" alt />
          </router-link>
          {{ _T('My Cashback') }}
        </h4>
      </div>
      <div class="account-body">
        <div class="wallet-content notification-section">
          <!-- <wallet-box />
          <div class="wallet-chart">
            <wallet-filter />
            <wallet-chart />
          </div>-->
          <ul
            class="notifications"
            v-if="customer_loyalty_cards && customer_loyalty_cards.length"
          >
            <li
              class="unread"
              v-for="(card, key) in customer_loyalty_cards"
              :key="key"
            >
              <div class="notification-icon">
                <img src="/images/svg/wallet/proceed.svg" alt />
              </div>
              <div class="details">
                <h6>
                  {{ _T('Your Cashback points') }}:
                  <span>{{ card.currency }} {{ Num.price(card.balance) }}</span>
                </h6>
              </div>
            </li>
          </ul>
          <ul v-else class="notifications">
            <li
              class="unread"
              v-for="(card, key) in customer_loyalty_cards"
              :key="key"
            >
              <div class="notification-icon">
                <img src="/images/svg/wallet/proceed.svg" alt />
              </div>
              <div class="details">
                <h6>
                  {{ _T('Your Cashback points') }}:
                  <span>{{ currency }} {{ Num.price(0) }}</span>
                </h6>
              </div>
            </li>
          </ul>
          <!-- <wallet-transactions /> -->
        </div>
      </div>
    </div>
    <top-up></top-up>
    <top-up-payment />
  </div>
</template>

<script>
// import WalletTransactions from '../Wallet/WalletTransactions'
// import WalletChart from '../Wallet/WalletChart'
// import WalletBox from '../Wallet/WalletBox'
// import WalletFilter from '../Wallet/WalletFilter'
import TopUp from '@/components/Modals/Topup/TopUp'
import TopUpPayment from '@/components/Modals/Topup/TopUpPayment'
import { mapGetters } from 'vuex'
export default {
  name: 'Wallet',
  components: {
    // WalletTransactions,
    // WalletChart,
    // WalletBox,
    // WalletFilter,
    TopUp,
    TopUpPayment,
  },
  computed: {
    ...mapGetters(['_T', 'customer_loyalty_cards']),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .account-menu {
    .account-breadcrumb {
      ul {
        padding-left: unset;
        padding-right: 0;
        text-align: right;
      }
    }
  }
}
.account-header {
  border-bottom: $px1 solid $light-border;
  padding: $px18 $px30;
  h4 {
    font-weight: 600;
    margin-bottom: 0;

    .mark-cls {
      font-size: $px14;
      line-height: $px22;
      color: $color-primary;
      float: right;
    }
  }
}
.wallet-content {
  padding: $px40;
  .nothing-found {
    font-weight: bold;
  }
  .media {
    align-items: center;

    /deep/ .dropdown {
      .dropdown-toggle {
        padding: $px8 $px14;
        border: $px1 solid $light-border;
        border-radius: $px4;
        display: flex;
        justify-content: space-between;
        width: $px140;

        &::after {
          display: none;
        }
      }
    }
  }

  .wallet-chart {
    /deep/ .dropdown {
      .dropdown-item {
        &.active,
        &:active {
          background-color: $color-primary;
        }
      }
    }

    /deep/ .apexcharts-ycrosshairs,
    .apexcharts-xcrosshairs {
      stroke: va($primary-5) !important;
    }

    /deep/.apexcharts-tooltip.light {
      box-shadow: 0px 3.48882px 8.72204px rgba($black, 0.1);
      border-radius: $px10;
      padding: $px15;
      border: none !important;

      .arrow_box {
        h4 {
          font-weight: bold;
          font-size: $px18;
          line-height: $px22;
          letter-spacing: 0.7px;
          margin-bottom: $px2;
        }
      }
    }

    /deep/.apexcharts-xaxistooltip,
    .apexcharts-yaxistooltip {
      display: none;
    }

    /deep/.apexcharts-xaxis {
      .apexcharts-xaxis-texts-g {
        text {
          font-weight: 600;
          font-size: $px14;
          line-height: $px22;
          letter-spacing: 0.005em;
          text-transform: uppercase;
        }
      }
    }

    /deep/.apexcharts-yaxis {
      .apexcharts-yaxis-texts-g {
        text {
          font-weight: 600;
          font-size: $px14;
          line-height: $px22;
          letter-spacing: 0.005em;
          fill: $light-font;
        }
      }
    }
  }
}
.account-breadcrumb {
  ul {
    li {
      line-height: $px17;
      letter-spacing: 0.005em;
      a {
        font-weight: 600;
      }
      img {
        margin-left: $px12;
        margin-right: $px7;
      }
    }
  }
  .breadcrumb-innerpage {
    li {
      font-weight: 600;
    }
  }
}
.account-menu {
  padding-top: $px40;
  .menu-left {
    margin-bottom: $px90;
    .menu-title {
      h4 {
        margin-bottom: calc(
          #{$px30} + (68 - 30) * ((100vw - #{$px320}) / (1920 - 320))
        );
        font-size: calc(
          #{$px16} + (20 - 16) * ((100vw - #{$px320}) / (1920 - 320))
        );
        line-height: $px24;
        color: $font-color;
        font-weight: 600;
        span {
          display: none;
        }
      }
    }
    ul {
      li {
        display: block;
        &.active {
          a {
            svg {
              path {
                fill: $primary-color !important;
              }
            }
            h4 {
              color: $primary-color;
            }
          }
        }
        a {
          svg {
            vertical-align: bottom;
          }
          h4 {
            display: inline-block;
            margin-bottom: 0;
            padding-left: $px6;
            color: $font-color;
            position: relative;
            .dot-notify {
              width: $px6;
              height: $px6;
              background-color: var(--primary-color);
              border-radius: 100%;
              position: absolute;
              top: 0;
              right: -$px12;
            }
          }
        }
        + li {
          margin-top: calc(
            #{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
      }
    }
  }
  .account-right {
    .account-breadcrumb {
      ul {
        li {
          line-height: $px17;
          letter-spacing: 0.005em;
          a {
            font-weight: 600;
          }
          img {
            margin-left: $px12;
            margin-right: $px7;
          }
        }
      }
      .breadcrumb-innerpage {
        li {
          font-weight: 600;
        }
      }
    }
    .account-card {
      box-shadow: 0px 4px 34px rgba($black, 0.07);
      margin: $px18 0 $px30;
      border-radius: $px10;
      .account-body {
        &.profile-media {
          .media {
            padding: calc(
                #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
              )
              calc(#{$px20} + (45 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
            align-items: center;
            .btn {
              padding: 8px
                calc(
                  #{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320))
                );
            }
            + .media {
              border-top: $px1 solid $light-border;
            }
            .profile-user {
              img {
                width: $px40;
                height: $px40;
                border-radius: 100%;
              }
            }
            .media-body {
              margin-left: $px20;
              h6 {
                margin-bottom: $px5;
                line-height: $px14;
                letter-spacing: 0.005em;
                color: rgba(var(--color-font-color-source), 0.44);
                font-weight: 500;
              }
              h4 {
                margin-bottom: 0;
                line-height: $px18;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
}
.notification-section {
  .notifications {
    li {
      display: flex;
      align-items: center;
      background: $light-border;
      padding: $px15 $px30;
      border-radius: $px5;
      .notification-icon {
        background: #ffffff;
        border-radius: $px15;
        width: $px52;
        height: $px52;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: $px30;
        }
      }
      .details {
        margin-left: $px30;
        max-width: 78%;
        h6 {
          font-style: normal;
          font-weight: 600;
          font-size: $px14;
          line-height: $px22;
          letter-spacing: 0.005em;
          color: $font-color;
          margin-bottom: 0;
          span {
            font-weight: 600;
            font-size: $px14;
            line-height: $px22;
            margin-left: $px42;
            letter-spacing: 0.005em;
            background: $warning-color;
            color: #fff;
            padding: $px5 $px10;
            border-radius: $px6;
          }
        }
      }
      &.read {
        background: white;
      }
      &:hover {
        background: #e6e8ef;
        .settings {
          opacity: 1;
          visibility: visible;
        }
      }
      + li {
        border-top: 1px solid $light-border;
        margin-top: $px15;
      }
    }
  }
}
@media (max-width: 575px) {
  .account-breadcrumb {
    display: none;
  }
  .account-card {
    box-shadow: none !important;
    margin: 0 !important;
  }
  .wallet-content {
    padding: $px15;
    &.notification-section {
      .notifications {
        li {
          .details {
            h6 {
              span {
                display: block;
                margin-left: 0;
                padding: $px3 $px8;
              }
            }
          }
        }
      }
    }
  }
}
</style>
